import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'p-calendar'
})
export class StopDblClickDirective {

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A' && target.getAttribute('href') === '#') {
      event.preventDefault();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/UIKit/directives/stop-double-click.directive.ts